export default function SafeMJ({ children, scrollable = false, after }) {
  if (scrollable) {
    return (
      <div className="overflow-x-auto overflow-y-hidden">
        <span>{children}</span>
        {after}
      </div>
    );
  }
  if (after) {
    return (
      <span className="whitespace-nowrap">
        <span>{children}</span>
        {after}
      </span>
    );
  }
  return <span>{children}</span>;
}
